import { selector } from "recoil";
import { organisationTableStateAtom } from "./organisation.ts";
import APIService from "../../APIService";
import { Apis } from "../../app.constants";
import { RecoilAtomKey } from "../../recoilConstantKey";
import { generateFilterKey } from "../../../utils/helper";

export const fetchOrganisationsSelector = selector({
  key: RecoilAtomKey.fetchOrganisationsSelectorKey,
  get: async ({ get }) => {
    const state = get(organisationTableStateAtom);
    const filterKey = generateFilterKey(state.filters);
    if (state.cache[filterKey]) {
      return {
        data: state.cache[filterKey],
        totalCount: state.totalCountCache[filterKey],
        fromCache: true
      };
    }
    try {
      let url = `${Apis.Get_Organisation_List}?next_page=${(state?.filters?.page || 0) + 1}&search=${state?.filters?.search}`;
      if (state?.filters?.category) {
        url += `&catgory=${state?.filters?.category}`;
      }
      if (state?.filters?.limit) {
        url += `&limit=${state?.filters?.limit}`;
      }
      const response = await APIService.get(url);
      return {
        data: response?.data?.list || [],
        totalCount: response?.data?.count || 0,
        fromCache: false
      };
    } catch (error) {
      return { data: [], totalCount: 0, fromCache: false };
    }
  },
});
